export default "__VITE_ASSET__K3ltKen2__"